import { queryOptions } from "@tanstack/react-query";
import * as aiApi from "./ai-api";
import type { SharedWith } from "@shared/types/supabase.types";

export const aiQueries = {
  all: () => ["ai_personas"] as const,
  lists: () => [...aiQueries.all(), "list"] as const,
  list: (
    filters: {
      sharedWith?: SharedWith;
      containerId?: string;
    } = {},
  ) =>
    queryOptions({
      queryKey: [...aiQueries.lists(), filters] as const,
      queryFn: () => aiApi.getAiPersonas(filters.sharedWith, filters.containerId),
    }),
};

export const aiKbQueries = {
  all: () => ["ai_assistant_kb"] as const,
  byPersona: (aiPersonaId: string, projectId?: string) =>
    queryOptions({
      queryKey: [...aiKbQueries.all(), aiPersonaId, projectId] as const,
      queryFn: () => aiApi.getAiAssistantKbItems(aiPersonaId, projectId),
      enabled: Boolean(aiPersonaId),
    }),
};
